/* eslint-disable import/prefer-default-export */
import env from 'bench-environment';

export const {
  apiRoot,
  v2BookkeepingApiRoot,
  categorizerApiPath,
  reportingApiPath,
  nodewayApiPath,
  salesforceApiPath,
  stripeApiPath,
} = env.location;
